// Entry and user slug parsing. No imports: src/params.js uses these, and SvelteKit imports
// that file with plain Node during `vite build`, outside Vite's aliases.

/**
 * Parses an entry slug to extract entry ID and title.
 * @param {string} slug - The entry slug to parse.
 * @returns {{entry_id: number|undefined, title: string|undefined}} An object containing the parsed entry ID and title.
 * @description Valid inputs: 2, some-slug-2, some-slug
 */ 
export function get_entry_id_and_title_from_slug(slug) {
  if (!slug) return { entry_id: undefined, title: undefined };

  let entry_id, title;

  if (/^\d+$/.test(slug)) {
    entry_id = parseInt(slug, 10);
  } else {
    const parts = slug.split('-');
    entry_id = parseInt(parts[parts.length - 1], 10);
    title = parts.slice(0, -1).join('-');
  }

  return { entry_id, title };
}


/**
 * Parses a user slug to extract user ID and name.
 * @param {string} slug - The user slug to parse.
 * @returns {{user_id: number|undefined, name: string|undefined}} An object containing the parsed user ID and name.
 */
export function get_user_id_and_name_from_slug(slug) {
  if (!slug || !slug.startsWith('@')) return { user_id: undefined, name: undefined };

  // Remove '@' from the beginning
  slug = slug.slice(1);

  let user_id, name;

  if (/^\d+$/.test(slug)) {
    user_id = parseInt(slug, 10);
  } else {
    const parts = slug.split('-');
    name = parts[0];
    user_id = parts.length > 1 ? parseInt(parts[parts.length - 1], 10) : undefined;
  }

  return { user_id, name };
}
